import FirebaseContext, { withFirebase } from './FirebaseContext';
import Firebase from './Firebase';

export default Firebase;

export { FirebaseContext, withFirebase };
